import { useCallback } from 'react';
import { toast } from 'components/ui/use-toast';
import { useNotificationsSocket } from './hooks';
import { renderNotification } from './renderers';
import type { INotification } from './types';

/**
 * Keeps the notifications socket open for the whole signed-in session, whichever
 * layout is on screen (app shell, candidate portal, a test in progress, focus
 * mode). It lives outside the bell because the bell exists only in the shell
 * header, and the platform counts online users from this socket.
 */
export function NotificationsSocketBridge(): null {
  // Show a toast for incoming notifications even when the dropdown is closed.
  // The renderer registry keeps per-type copy in one place.
  const handleNew = useCallback((notification: INotification) => {
    const rendered = renderNotification(notification);
    toast.info(rendered.title, { description: rendered.body || undefined });
  }, []);

  useNotificationsSocket({ onNew: handleNew });
  return null;
}
